<template>
  <div class="energy-ring">
    <title-one class="m-top" :title="title || ''" :ps-txt="psTxt" />
    <div class="rank-three left">
      <mul-ring :energy-consumption-data="energyConsumptionData" />
    </div>
  </div>
</template>

<script>
import TitleOne from '@/components/TitleOne/TitleOne'
import MulRing from '@/views/Home/components/MulRing'
export default {
  name: 'EnergyRing',
  components: { MulRing, TitleOne },
  props: {
    title: {
      type: String,
      default: () => ''
    },
    psTxt: {
      type: String,
      default: ''
    },
    energyConsumptionData: {
      type: Array,
      default: () => ({})
    }
  }
}
</script>

<style lang="less" scoped>
  .rank-three{
    width: 100%;
    height: 241px;
    background: url("../../images/left-3.png") top left no-repeat;
    background-size: 100% 100%;
  }
  .left{
    position: relative;
    top: -6px;
  }
</style>
